export const MUTATION_GROUP = 'singleVersionPickerFields' as const;
